module.exports = __webpack_public_path__ + "img/salary.daccad8c.svg";